<ph-stack gap="tight">
    <ph-toolbar nowrap>
        <ph-label>{{ section.label }}</ph-label>
        <ph-badge class="ap-recipients-count" variant="light" color="gray" size="small">{{ activeCount() }} {{ activeCount() === 1 ? 'unit' : 'units' }}</ph-badge>
    </ph-toolbar>

    <app-unit-picker pickerKey="gableActionRecipients" *ngIf="!isOverflowing"
                     class="ap-recipients-picker"
                     [columns]="unitColumns"
                     [canShowDeleted]="false"
                     [listHeight]="300"
                     [preselectedUnitIds]="existingUnitIds"
                     (unitIdsChange)="onSelectionChange($event)"></app-unit-picker>

    <ph-scroll-area *ngIf="isOverflowing" max-height="350px">
        <ph-list-row *ngFor="let item of section.items; trackBy: trackByItemId"
                     class="ap-recipient-row"
                     [class.is-removed]="isRemoved(item)"
                     [heading]="item.primary"
                     [meta]="item.secondary || ''"
                     [muted]="isRemoved(item)">
            <ph-compact-button *ngIf="item.removable" slot="actions"
                               [icon]="isRemoved(item) ? 'arrow-counter-clockwise' : 'x'"
                               [ariaLabel]="(isRemoved(item) ? 'Restore ' : 'Remove ') + item.primary"
                               (click)="toggleRemove(item)"></ph-compact-button>
        </ph-list-row>
    </ph-scroll-area>

    <ph-hint class="ap-recipients-overflow" *ngIf="overflowCount > 0">+{{ overflowCount }} more not shown. The list is too large to edit one by one.</ph-hint>
</ph-stack>
